<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 ご注文内容の確認
        v-layout.container.justify-center(row wrap)
          v-layout.text-xs-center.my-5.stepper(row wrap)
            v-flex(xs12)
              p.my-3 ご注文の流れ
              ul.list-unstyled.multi-steps
                li.is-active
                  | ご注文内容の確認
                  br
                  | お客様情報・配送指定
                li ご入力内容の確認
                li 注文完了
        v-layout.pa-3.mt-3.white_container.justify-center(row wrap)
          h2 ショッピングカート
          p.text-xs-center.my-4 ご注文内容をご確認ください。
          v-container
            v-layout.cart_list(row wrap v-for="(item, index) in cart" :key="item.key")
              v-flex.text-xs-center.index(md1) {{index + 1}}
              v-flex.text-md-left.mb-2(md6) {{item.name}}
              v-flex(md1 xs3)
                span 数量
                v-text-field(
                  type="number"
                  min="1"
                  outline color="primary"
                  @input="updateItemNum({uuid: item.uuid, num: $event})"
                  :value="item.num"
                  )
              v-flex.text-xs-right(md3 xs9)
               |単価（税込） {{item.price|number}}
               br
               |価格（税込） {{item.sub_total|number}}
              v-flex.text-md-center.text-xs-right(md1)
                v-btn(color="grey darken-1" small icon flat round @click="removeItem(item)")
                  v-icon delete_forever

            div.mt-3(v-if="cart.length === 0")
              v-alert(type="info" color="error" outline :value="true") カートに商品がありません。
            v-container.btn_wrap
              v-layout(row wrap)
                v-flex(xs12 md4 offset-xs0 offset-md4)
                  router-link(to="top" tag="div")
                    v-btn(color="primary" flat outline round block)
                      span 買い物を続ける

          v-container(grid-list-md)
            v-layout(row wrap v-if="customer")
              v-flex(xs12)
                h2 お客様情報の入力
                v-subheader お客様情報をご入力ください。
                span.form_req *印は必須項目です。

              v-flex(xs12 sm6)
                v-text-field(
                  label="お名前*"
                  @input="updateCustomer({name: $event})"
                  :value="customer.name"
                  prepend-icon="face"
                  ref="name"
                  :rules="[rules.required]"
                  )
              v-flex(xs12 sm6)
                v-text-field(
                  label="E-mail*"
                  @input="updateCustomer({email: $event})"
                  :value="customer.email"
                  prepend-icon="mail"
                  ref="email"
                  :rules="[rules.required,rules.email]"
                  )
              v-flex(xs12 sm6)
                v-text-field(
                  label="お電話番号"
                  @input="updateCustomer({tel: $event})"
                  :value="customer.tel"
                  hint="（例：025-275-8185,0252758185 半角数字)"
                  prepend-icon="phone"
                  )
              v-flex(xs12 sm6)
                v-text-field(
                  label="郵便番号*"
                  @input="updateCustomer({zipcode: $event})"
                  :value="customer.zipcode"
                  prepend-icon="home"
                  placeholder="000-0000"
                  hint="（例：123-4567,1234567 半角数字7桁）"
                  ref="zipcode"
                  :rules="[rules.required]"
                  @blur="autoloadAddress"
                  )
              v-flex(xs12 sm2)
                v-btn(
                  raised
                  outline
                  block
                  round
                  color="brown darken-4"
                  @click="autoloadAddress"
                  :disabled="customer.zipcode === null || customer.zipcode.length === 0"
                  )
                  | 住所自動入力
              v-flex(xs12)
                span(style="font-size: .9rem") ※お間違えのないよう、住所は郵便番号から自動入力することをおすすめします。
              v-flex(xs12 sm2)
                v-select(
                  :items="prefs"
                  @input="updateCustomer({pref: $event})"
                  :value="customer.pref"
                  label="都道府県"
                  ref="pref"
                  :rules="[rules.required]"
                )
              v-flex(xs12 sm6)
                v-text-field(
                  label="ご住所*"
                  @input="updateCustomer({address1: $event})"
                  :value="customer.address1"
                  placeholder="市区町村名"
                  ref="adrress1"
                  :rules="[rules.required]"
                  )
              v-flex(xs12 sm4)
                v-text-field(
                  label="番地・ビル名"
                  @input="updateCustomer({address2: $event})"
                  :value="customer.address2"
                  hint="アパート・マンション名は必ず記入してください。"
                  )

          v-container(grid-list-md)
            v-layout(row wrap)
              v-flex(xs12)
                h2 配送指定
                p ご希望の配送日時をご入力ください。
              v-flex(xs12 sm6)
                v-subheader 配送希望日
                v-menu(
                  lazy
                  :close-on-content-click="false"
                  v-model="desiredDatePicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                )
                  v-text-field(
                    slot="activator"
                    :value="customer.desired_delivery_date|date"
                    prepend-icon="date_range"
                    ref="desire_delivery_date"
                    :rules="[rules.required,rules.date]"
                    readonly
                  )
                  v-date-picker(
                    @input="updateCustomer({desired_delivery_date: $event})"
                    :value="customer.desired_delivery_date"
                    :allowed-dates="allowedDates"
                  )
              v-flex(xs12 sm6)
                v-subheader(for="desired_delivery_time") 配送希望時間帯
                v-select(
                  :items="selectionTimes"
                  @input="updateCustomer({desired_delivery_time: $event})"
                  :value="customer.desired_delivery_time"
                  prepend-icon="access_time"
                  item-value="text"
                  ref="desire_delivery_time"
                  :rules="[rules.required]")
              .order_notes.mt-2
                p 【ご注意】
                p.ml-2 ※お届け日は土日のみとなります。
                p.ml-2 ※午前11時以降のご注文は次回出荷日分のご対応となります。
                  | ご指定いただいた配送希望日・配送希望時間帯のご希望に沿えない場合、弊社から改めてご連絡させて頂きます。ご了承下さい。
                v-layout(row wrap v-show="!item.hide" v-for='(item, index) in schedule' :key="index")
                  p.mt-3 【{{ item.title }} 】
                    ul.ml-2(v-for='item in item.list')
                      li {{ item.topic }}
          v-container(v-if="cart.length > 0")
            v-layout(row rwap)
              v-flex(xs12 sm6 offset-sm6 md4 offset-md8)
                .app-line
                  span.app-line-title 小計
                  span.app-line-text {{summary.total|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 送料
                  span.app-line-text {{summary.delivery_fee|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 代引手数料
                  span.app-line-text {{summary.cod_fee|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 合計金額
                  span.app-line-text {{summary.grand_total|number}}
                  span.app-line-suffix 円
          v-layout.mt-5(row wrap)
            v-flex(md4 offset-md4)
              v-btn(
                color="primary"
                round
                block
                outline
                @click="toConfirm"
                :disabled="cart.length === 0 || customer.pref === null || summary.cod_fee === 0"
                )
                span ご購入手続きに進む
            v-flex.text-xs-center.mt-5(md12)
              router-link(to='privacy') プライバシーポリシー
    CommonFooter
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'
import rules from '@/common/mixins/rules'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted () {
    this.$vuetify.theme.error = '#9e5d0d'
    this.$vuetify.theme.accent = '#9e5d0d'
  },
  data () {
    return {
      desiredDatePicker: false,
      forbiddenDates: ['2019-05-04', '2019-05-05', '2019-08-17', '2019-08-18'],
      schedule: [
        {
          hide: true,
          title: '年末年始の配送スケジュールについて',
          list: [{
            'topic': '本年の最終出荷分は12月27日（金）AM11時までとなります。'
          }, {
            'topic': '12月27日（土）AM11時以降のご注文分は年末年始明けの手配になりますのでご注意ください。'
          }, {
            'topic': '年明けは1月6日（月）からご注文を承ります。'
          }]
        }
      ]
    }
  },
  mixins: [rules],
  created () {
    this.reloadCustomer()
  },
  computed: {
    ...mapGetters('app/shop', [
      'cart',
      'cartNum',
      'customer',
      'summary',
      'deliveryTimeTable',
      'prefs'
    ]),
    selectionTimes () {
      return this.deliveryTimeTable.map(time => {
        return {
          text: time
        }
      })
    }
  },
  methods: {
    ...mapActions('app/shop', [
      'reloadCustomer',
      'updateCustomer',
      'saveCustomer',
      'removeItem',
      'updateItemNum'
    ]),
    allowedDates (val) {
      return (
        !this.forbiddenDates.includes(val) &&
        this.$moment().format('YYYY-MM-DD') < val &&
        [0, 6].includes(this.$moment(val).day())
      )
    },
    autoloadAddress () {
      if (
        this.customer.zipcode === null ||
        !this.customer.zipcode.match(/^\d{3}-?\d{4}$/)
      ) {
        return true
      }
      this.$ajax.get(`https://api.zipaddress.developstep.com?zipcode=${this.customer.zipcode}`)
        .then((data) => {
          this.updateCustomer({
            pref: data.data.pref,
            address1: `${data.data.city}${data.data.town}`,
            address2: ''
          })
        })
        .catch(() => {
          this.$toastr.info(
            '自動入力に失敗しました。お手数ですが、住所を手入力いただきますようお願いいたします。'
          )
        })
    },
    toConfirm () {
      if (this.hasRuleError()) {
        this.$toastr.warning('入力に不備があります。')
        return true
      }
      this.saveCustomer()
      this.$router.push('cart_confirm')
    }
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Cart/index.vue